import { ChangeDetectionStrategy, Component, OnInit, input } from "@angular/core";
import { IonicModule, ModalController } from "@ionic/angular";
import { ModeService } from "src/app/utils/mode.service";
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { ProductDto } from "../../interfaces/product_dto";
import { upsertProduct } from "../../ngrx/products.actions";
import { Store } from "@ngrx/store";

@Component({
    selector: "app-product-form",
    templateUrl: "./product-form.component.html",
    styleUrls: ["./product-form.component.scss"],
    imports: [IonicModule, FormsModule, ReactiveFormsModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductFormComponent implements OnInit {
  productForm: FormGroup;

  readonly product = input<ProductDto>(undefined);

  constructor(
    public modeService: ModeService,
    private modalController: ModalController,
    private store: Store<any>
  ) {
    this.productForm = new FormGroup({
      name: new FormControl("", Validators.required),
      prize: new FormControl(null, Validators.required),
      description: new FormControl(""),
      unit: new FormControl("Stk", Validators.required),
      product_id: new FormControl(null),
    });
  }

  ngOnInit() {
    let product = { ...this.product() };
    if (product) {
      this.productForm.patchValue(product);
    } else {
      this.productForm.get("product_id")?.disable();
    }
  }

  async cancel() {
    if (await this.modalController.getTop()) {
      this.modalController.dismiss();
    }
  }

  save() {
    const formValue = this.productForm.value;
    const product: ProductDto = {
      name: formValue.name,
      prize: formValue.prize,
      description: formValue.description,
      unit: formValue.unit,
      ...(formValue.product_id && { product_id: formValue.product_id })
    };

    this.store.dispatch(upsertProduct({ product }));

    if (this.modalController.getTop()) {
      this.modalController.dismiss(product);
    }
  }
}
